export const formatNumber = (value) => {
  // Ensure that the value is displayed with trailing zeros only when necessary
  const floatValue = parseFloat(value);
  return floatValue.toFixed(2);
};

export function formatPrice(val = 0) {
  const numberValue = Number(val);
  if (!numberValue) {
    return 0;
  }
  return Number(numberValue).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
}
